import {NgModule} from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';

import {NavComponent} from './nav.component';

import {MaterialModules} from '../../app.material';
import {CoreMondules} from '../../core/core.modules';
import {SplashScreenComponent} from '../splashscreen/splash-screen.component';


@NgModule({
    declarations:[
        NavComponent,
        SplashScreenComponent
    ],
    exports:[
        NavComponent,
        SplashScreenComponent
    ],
    
    imports:[
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModules,
        CoreMondules,
        RouterModule
    ],
    providers:[
    ]
})
export class NavagationModule {}